import React from 'react'

const MAX_TAB_INDEX = 32767

export const FocusOnMount: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const ref = React.useRef<HTMLDivElement>(null)

    function getTabIndex(element: Element) {
        return Number(element.getAttribute('tabindex'))
    }

    function isUserTyping() {
        return document.activeElement?.tagName === 'INPUT'
    }

    // Finds and focuses on the first tabbable child of this component.
    React.useEffect(() => {
        if (!ref.current || isUserTyping()) return

        let firstTabbableElement: HTMLElement | undefined
        const tabbableElements = ref.current.querySelectorAll('[tabindex]')

        tabbableElements.forEach(tabbableElement => {
            const firstTabIndex = firstTabbableElement ? getTabIndex(firstTabbableElement) : Number.MAX_SAFE_INTEGER
            let tabIndex = getTabIndex(tabbableElement)

            // A tab index of 0 grants focus after any positive number.
            if (tabIndex === 0) tabIndex = MAX_TAB_INDEX + 1 

            // Find element with the closest tab index to 1.
            if (tabIndex > 0 && tabIndex < firstTabIndex) {
                firstTabbableElement = tabbableElement as HTMLElement
            } 
        })

        const messagesContainerElements = document.querySelectorAll('div[aria-live]');

        if (firstTabbableElement) {
            messagesContainerElements.forEach((el) => el.setAttribute('aria-live', 'off'))
            firstTabbableElement.focus();

            setTimeout(() => {
                messagesContainerElements.forEach((el) => el.setAttribute('aria-live', 'polite'))
            }, 100)
        }
    }, [])

    return (
        <div ref={ref}>
            {children}
        </div>
    )
}